<template>
  <div>
    <el-dialog :visible.sync="visible" width="40%" :close-on-click-modal="false" :append-to-body="true"
      @close="dialogClose">
      <div class="loginDialog">
        <div class="title">登录</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- ########### 账号密码登录 ########### -->
          <el-tab-pane label="账号密码登录" name="1">
            <el-form :model="form" style="margin-top: 50px;">
              <el-form-item>
                <el-input style="height: 56px;" v-model="form.account" placeholder="请输入手机号码">
                  <img class="iconImg" slot="prefix" src="../../assets/images/zhanghao.png">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input type="password" v-model="form.password" placeholder="请输入密码">
                  <img class="iconImg" slot="prefix" src="../../assets/images/mima.png">
                </el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- ########### 短信验证码登录 ########### -->
          <el-tab-pane label="短信验证码登录" name="2">
            <el-form :model="form2" style="margin-top: 50px;">
              <el-form-item>
                <div class="inputBox">
                  <el-input style="height: 56px;width: 70%;" v-model="form2.account" placeholder="请输入手机号码">
                    <img class="iconImg" slot="prefix" src="../../assets/images/zhanghao.png">
                  </el-input>
                  <el-button @click="countDown" :disabled="isSend" class="code">{{codeName}}</el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <el-input v-model="form2.code" placeholder="请输入短信验证码">
                </el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="bottomTips">
          <div @click="forgetPassword">忘记密码？</div>
          <div @click="register">注册</div>
        </div>
        <div class="btnBox">
          <el-button class="btn" @click="login">登录</el-button>
        </div>
        <div class="bottomTitle">
          <el-checkbox v-model="checked"></el-checkbox>
          <span>我已阅读并同意<span class="sp">《用户协议》</span>与<span class="sp">《隐私权政策》</span></span>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
  import {
    login,
    loginCaptcha,
    sendCode,
    userVerificationCode
  } from "@/api/login";
  import md5 from "js-md5";
  export default {
    props: {
      dialogFormVisible: {
        type: Boolean,
        default: function() {
          return false
        }
      },
    },
    data() {
      return {
        form: {},
        form2: {},
        visible: false,
        activeName: '1',
        checked: true,
        codeName: '获取短信验证码',
        isSend: false, //禁用
        totalTime: 60, //一般是60
        timer: '', //定时器
      }
    },
    watch: {
      dialogFormVisible() {
        this.visible = this.dialogFormVisible;
      },
    },
    methods: {
      login() {
        console.log(this.activeName)
        if (this.activeName == '1') {
          let data = `account=${this.form.account}&password=${md5(this.form.password)}`
          login(data).then(res => {
            console.log(res)
            if (res.data.access_token) {
              this.$message({
                type: "success",
                message: '登录成功'
              });
              localStorage.setItem('token', res.data.access_token)
              localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
              this.$emit("update:dialogFormVisible", false);
              this.$emit('login', res.data.userInfo.userName)
              this.visible = false
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          let query = `phone=${this.form2.account}&verificationCode=${this.form2.code}`
          userVerificationCode(query).then(res => {
            if (res.code == 200) {
              let data = `account=${this.form2.account}&captcha=${this.form2.code}`
              loginCaptcha(data).then(res => {
                console.log(res)
                if (res.data.access_token) {
                  this.$message({
                    type: "success",
                    message: '登录成功'
                  });
                  localStorage.setItem('token', res.data.access_token)
                  localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
                  this.$emit("update:dialogFormVisible", false);
                  this.$emit('login', res.data.userInfo.userName)
                  this.visible = false
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg
                  });
                }
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      },
      register() {
        this.$emit("register", true);
      },
      forgetPassword() {
        this.$emit("forgetPassword", true);
      },
      // 验证码倒计时
      countDown() {
        if (this.isSend) return
        this.getCode() // 获取验证码的接口
      },
      getCode() {
        let data = `phone=${this.form2.account}`
        sendCode(data).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.isSend = true
            this.codeName = this.totalTime + 's后重新发送'
            this.timer = setInterval(() => {
              this.totalTime--
              this.codeName = this.totalTime + 's后重新发送'
              if (this.totalTime < 0) {
                clearInterval(this.timer)
                this.codeName = '重新发送验证码'
                this.totalTime = 60
                this.isSend = false
              }
            }, 1000)
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      handleClick(tab, event) {
        console.log(tab, event)
      },
      submit() {
        //visible是父组件传过来的props，子组件不能直接修改，需要子传父
        this.$emit("update:dialogFormVisible", false);
        this.visible = false
      },
      dialogClose() {
        this.$emit("update:dialogFormVisible", false);
        this.visible = false
      }
    },
  }
</script>

<style scoped>
  .loginDialog {
    padding: 0 72px 0 72px;
  }

  .title {
    font-size: 36px;
    color: #215ACE;
    font-weight: 600;
    text-align: center;
    margin-bottom: 56px;
  }

  .iconImg {
    width: 32px;
    height: 32px;
    margin-top: 12px;
  }

  .inputBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .code {
    width: 221px;
    height: 56px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid #215ACE;
    color: #215ACE;
    font-size: 18px;
    margin-left: 16px;
  }

  .bottomTips {
    font-size: 16px;
    color: #000000;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottomTips div {
    cursor: pointer;
  }

  .btnBox {}

  .btnBox .btn {
    width: 100%;
    height: 56px;
    background: #3E79F6;
    border-radius: 8px;
    border: 1px solid #3E79F6;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 80px;
  }

  .bottomTitle {
    margin-top: 17px;
    color: #000000;
  }

  .bottomTitle .sp {
    color: #3065E4;
  }

  >>>.el-input__inner {
    height: 56px;
    padding-left: 40px;
    line-height: 56px;
    font-size: 14px;
  }

  >>>.el-input__inner:last-child {
    padding-left: 20px;
  }

  >>>.el-tabs__nav-wrap::after {
    background-color: #fff;
  }

  >>>.el-tabs__item {
    font-size: 16px;
    font-weight: 600;
  }

  >>>.el-input__inner::-webkit-input-placeholder {
    /* placeholder颜色 */
    /* color: #aab2bd; */
    /* placeholder字体大小 */
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue